/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_1_DescInputs */

const en_mk_problem_1_desc = /** @type {(inputs: Mk_Problem_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employees paste company data into personal ChatGPT accounts. No one knows what leaves, and nothing is auditable.`)
};

const id_mk_problem_1_desc = /** @type {(inputs: Mk_Problem_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karyawan menempel data perusahaan ke akun ChatGPT pribadi. Tidak ada yang tahu data apa yang keluar, dan tidak ada yang bisa diaudit.`)
};

/**
* | output |
* | --- |
* | "Employees paste company data into personal ChatGPT accounts. No one knows what leaves, and nothing is auditable." |
*
* @param {Mk_Problem_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_1_desc = /** @type {((inputs?: Mk_Problem_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_1_desc(inputs)
	return en_mk_problem_1_desc(inputs)
});